"use client"

import { Sheet, SheetContent } from "@/components/sheet"

type ConnectMenuProps = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
}

export const ConnectMenu = ({ isOpen, onOpenChange, children }: ConnectMenuProps) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:w-10/12 sm:max-w-md">
        {children}
      </SheetContent>
    </Sheet>
  )
}
